import { IconProps } from '.';

const BookIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142898)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.75 30V9.58333H19.25V30H16.75Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 0H13C16.4518 0 19.25 2.79822 19.25 6.25V30H0.5V0ZM3 2.5V27.5H16.75V6.25C16.75 4.17893 15.0711 2.5 13 2.5H3Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.5 0H23C19.5482 0 16.75 2.79822 16.75 6.25V30H35.5V0ZM33 2.5V27.5H19.25V6.25C19.25 4.17893 20.9289 2.5 23 2.5H33Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.25 19.1667H21.75V16.6667H29.25V19.1667Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5833 24.1667H21.75V21.6667H27.5833V24.1667Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142898">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BookIcon;
